import { getResponsiveImageData, ImageAspectRatio } from '@jtnews/shared/images';

import { ForumProfileData, AuthUserInfo, ForumMenuItem } from '../domain';

import type {
  AuthUserInfoDTO,
  ForumProfileDataDTO,
  ForumMenuItemDTO
} from './user-api.service';

export class UserMapperService {
  public static getUserInfoDO(userInfoDTO: AuthUserInfoDTO): AuthUserInfo {
    const avatarData = getResponsiveImageData({
      url: userInfoDTO.avatar,
      width: 36,
      aspectRatio: ImageAspectRatio.Square,
      values: [
        {
          width: 36,
          breakpoint: 0,
          noMedia: true
        }
      ]
    });

    return {
      avatar: userInfoDTO.avatar,
      avatarData: {
        src: avatarData.data.src,
        sources: avatarData.data.sources
      },
      commentFormProfileLink: userInfoDTO.commentFormProfileLink,
      email: userInfoDTO.email,
      gameStat: userInfoDTO.gameStat,
      hasMailAccount: userInfoDTO.hasMailAccount,
      hasMailsCounter: userInfoDTO.hasMailsCounter,
      hasProfile: userInfoDTO.hasProfile,
      link: userInfoDTO.link,
      login: userInfoDTO.login,
      sex: userInfoDTO.sex,
      userId: userInfoDTO.userId,
      isBlocked: userInfoDTO.isBlocked,
      isTrusted: userInfoDTO.trusted,
      responseTime: userInfoDTO.responseTime,
      notifyEmail: userInfoDTO.notifyEmail,
      isNotifyEmailValidated: userInfoDTO.isNotifyEmailValidated,
      bookmarks: userInfoDTO.bookmarks,
      featureFlags: userInfoDTO.featureFlags
    };
  }
  public static getForumProfileDataDO(
    profileDataDTO: ForumProfileDataDTO
  ): ForumProfileData {
    return {
      id: profileDataDTO.id,
      passportId: profileDataDTO.passportId,
      login: profileDataDTO.login,
      email: profileDataDTO.email,
      link: profileDataDTO.link,
      avatarData: {
        src: profileDataDTO.avatar,
        sources: []
      },
      sex: profileDataDTO.sex,
      menu: UserMapperService._getForumMenuItems(profileDataDTO.menu)
    };
  }

  private static _getForumMenuItems(menu: ForumMenuItemDTO[]): ForumMenuItem[] {
    return menu.map(item => ({
      id: item.id,
      name: item.name,
      link: item.link,
      count: item.count || 0
    }));
  }
}
